import React from 'react';
import { Button } from '@mui/material';
import { isEmpty } from 'lodash';
import LedgerDialogProps from './LedgerDialog.props';
import { StyledCancelButton, StyledDialogActions, StyledDialogContent, StyledDialogTitle } from './LedgerDialog.styles';

const LedgerDialog = ({
  actionButtonText,
  children,
  dialogContentStyle,
  dialogHeader,
  disabled = false,
  disableSaveButton = false,
  id,
  onClose,
  onSave,
  title,
}: LedgerDialogProps) => (
  <div id={id} data-testid={id}>
    {!isEmpty(title) && <StyledDialogTitle id={`${id}-title`}>{title}</StyledDialogTitle>}
    {dialogHeader}
    <StyledDialogContent style={dialogContentStyle}>{children}</StyledDialogContent>
    <StyledDialogActions>
      <StyledCancelButton variant="text" id={`${id}-cancel-btn`} onClick={onClose}>
        {actionButtonText?.cancel ?? 'Cancel'}
      </StyledCancelButton>
      {onSave && (
        <Button
          id={`${id}-save-btn`}
          data-testid={`${id}-save-btn`}
          disabled={disableSaveButton || disabled}
          variant="contained"
          color="secondary"
          onClick={onSave}>
          {actionButtonText?.save ?? 'Save'}
        </Button>
      )}
    </StyledDialogActions>
  </div>
);

export default LedgerDialog;
